import React from 'react';
export default function(){
  return(
          <div id="app-info">
            <p>6afa475dfd2dfae9bc18f845d010a96f59c14e5d</p>
            <p>    using the resized image insetad of ignoring it</p>
          </div>
  )
}

